import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { userRoles } from "../../constant";
import { useUser } from "../../services/user-context";
import { AdminCertificationDashboard } from "./admin-certification/AdminCertificationDashboard";
import { UserCertificationsWrapper } from "./UserCertificationsWrapper";
import { useCertificationTypeSelect, getInitialCertificationType } from "./components/CertificationTypeSelect";

export function Certifications() {
  const { userInfo } = useUser() as any;
  const role = userInfo?.role;
  const { certificationType, setCertificationType } = useCertificationTypeSelect();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    setCertificationType(getInitialCertificationType(searchParams));
  }, [searchParams, setCertificationType]);

  if ([userRoles.Trainer, userRoles.Admin].includes(role) || (userRoles.Manager === role && certificationType === userRoles.Manager )) {
    return <AdminCertificationDashboard setCertificationType={setCertificationType} certificationType={certificationType} />;
  }
  return (
    <>
      <UserCertificationsWrapper isAccountSpecialist={!role || (userRoles.AccountSpecialist === role || userRoles.SalesRep === role)} setCertificationType={setCertificationType} certificationType={certificationType} />
    </>
  );
}
